import React from "react";
import contactImage from "../../assets/mig1.jpg";

export default function MissionSection() {
    return (
        <section className="relative py-24 bg-slate-950 text-white">
            <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_rgba(56,189,248,0.15),_transparent_60%)]" />
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
                    <div className="lg:col-span-7">
                        <h2 className="text-3xl md:text-4xl font-extrabold">Our Mission</h2>
                        <p className="mt-4 text-slate-300 text-lg">
                            Accessible, reliable, and compassionate immigration services — with a clear path and a real human beside you.
                        </p>

                        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
                            {["Compassionate service throughout your journey", "Fast and efficient form processing", "Transparent pricing — no surprises", "24/7 availability and updates"].map((item, i) => (
                                <div key={i} className="flex items-start gap-3 rounded-xl bg-white/5 ring-1 ring-white/10 p-4">
                                    <span className="mt-0.5 inline-flex h-7 w-7 items-center justify-center rounded-full bg-emerald-400/20 text-emerald-300 ring-1 ring-emerald-300/30">
                                        <svg className="w-4.5 h-4.5" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                        </svg>
                                    </span>
                                    <span className="text-slate-200">{item}</span>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="lg:col-span-5">
                        <div className="relative rounded-2xl overflow-hidden ring-1 ring-white/10 bg-white/5">
                            <img src={contactImage} alt="Office" className="h-full w-full object-cover aspect-video" />
                            <div className="absolute inset-0 bg-gradient-to-t from-slate-950/60 to-transparent" />
                            <div className="absolute bottom-0 p-6">
                                <div className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 ring-1 ring-white/15">
                                    <span className="h-2 w-2 rounded-full bg-emerald-400 animate-pulse" />
                                    <span className="text-sm text-white/90 font-medium">We’re online 24/7</span>
                                </div>
                                <p className="mt-3 text-sm text-slate-200 max-w-md">Speak to a specialist any time. Clear answers. Real timelines.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}